import { moment } from 'localization'
import { i18n, dateTimeFormat } from 'localization'
export default class Document {
	static fromJSON(json) {
		return new Document(json.fileId, json.name)
			.withType(json.type)
			.withCreateAt(json.date)
			.withAppointment(json.appointmentId)
			.withRequisition(json.requisitionId)
			.withDescription(json.description)
			.withExamExternalLink(json.externalLink)
	}

	constructor(id, name) {
		this.id = id
		this.name = name
	}

	withType(json) {
		this.type = json
			? {
					id: json.id,
					name: i18n.translate((json.name || '').trim()),
			  }
			: null
		return this
	}

	withCreateAt(dateStr) {
		if (!dateStr) {
			this.createAt = null
			return this
		}
		const dateTime = moment(new Date(dateStr))
		const date = dateTime.format(dateTimeFormat.date || 'MMM DD, YYYY')
		const time = dateTime.format(dateTimeFormat.time || 'HH:mm')
		const dateTimeString = dateTime.format(
			dateTimeFormat.dateTime || 'MMM DD, YYYY [at] HH:mm'
		)
		this.createdAt = {
			shortDateFormat: date,
			shortTimeFormat: time,
			dateTimeFormat: dateTimeString,
		}
		return this
	}

	withAppointment(appointmentId) {
		this.appointmentId = appointmentId
		return this
	}
	withRequisition(requisitionId) {
		this.requisitionId = requisitionId
		return this
	}

	withDescription(description) {
		this.description = description
			? description.trim()
			: i18n`Without description`
		return this
	}

	withExamExternalLink(externalLink) {
		this.externalLink = externalLink
		return this
	}
}
